import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import StudentMainProfile from "../../components/sections/StudentMainProfile";
import DynamicProfile from "../instructor/pages/DynamicProfile";
import HelpPage from "../instructor/pages/HelpPage";
import StudentMontessoriMenu from "./StudentMontessoriMenu";
import FriendsPage from "./pages/FriendsPage";
import Index from "./pages/Index";
import NotificationList from "./pages/NotificationList";
import Settings from "./pages/Settings";
import StudentMontessoriReportList from "./pages/is-kool-jr/montessori-progress-card/StudentMontessoriReportList";
import StudentMontessoriViewCard from "./pages/is-kool-jr/montessori-progress-card/StudentMontessoriViewCard";
import StudentSwitchTransportation from "./pages/transportation/StudentSwitchTransportation";
import StudentLiveTracking from "./pages/Live tracking";
import SwitchMontessoriAttendance from "./pages/is-kool-jr/attendance/SwitchMontessoriAttendance";
import HomeWork from "./pages/is-kool-jr/message/HomeWorkBroadcast";

const url = "/dashboard";

const StudentMontessoriRoutes = () => {
  return (
    <Routes>
      <Route path="student/menu" element={<StudentMontessoriMenu />} />
      <Route path="student/menu/profile" element={<StudentMainProfile />} />
      <Route path="student/menu/friends" element={<FriendsPage />} />
      <Route path="student/menu/homework" element={<HomeWork />} />
      <Route path="student/menu/diary" element={<DiaryBoard role="student" mode="junior" />} />
      <Route path="student/menu/friends/:userId" element={<DynamicProfile />} />
      <Route path="student/help" element={<HelpPage />} />
      <Route path="student/menu/notifications" element={<NotificationList />} />
      <Route path="student/menu/setting/" element={<Settings />} />
      <Route path="student/menu/attendance" element={<SwitchMontessoriAttendance />} />
      <Route path="student/menu/transportation/" element={<StudentSwitchTransportation />} />
      <Route path="student/menu/live-tracking/" element={<StudentLiveTracking />} />
      <Route path="student/home" element={<Index />} />
      <Route path="student/menu/montessori-report-card/" element={<StudentMontessoriReportList />} />
      <Route path="student/menu/montessori-report-card/:id" element={<StudentMontessoriViewCard />} />
      <Route index element={<Navigate to={`${url}/student/home`} replace />} />
    </Routes>
  );
};

export default StudentMontessoriRoutes;
